import React from 'react';

export const Cloud = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill="#EFF6FF" />
    <g clipPath="url(#clip0_2719_2140)">
      <path
        d="M27.21 19.04L25.68 18.93L25.38 17.43C24.88 14.86 22.62 13 20 13C17.94 13 16.08 14.14 15.12 15.96L14.62 16.91L13.55 17.02C11.53 17.24 10 18.95 10 21C10 23.21 11.79 25 14 25H27C28.65 25 30 23.65 30 22C30 20.45 28.78 19.14 27.21 19.04Z"
        fill="#D1E3FF"
      />
      <path
        d="M27.35 17.04C26.67 13.59 23.64 11 20 11C17.11 11 14.6 12.64 13.35 15.04C10.34 15.36 8 17.91 8 21C8 24.31 10.69 27 14 27H27C29.76 27 32 24.76 32 22C32 19.36 29.95 17.22 27.35 17.04ZM27 25H14C11.79 25 10 23.21 10 21C10 18.95 11.53 17.24 13.56 17.03L14.63 16.92L15.13 15.97C16.08 14.14 17.94 13 20 13C22.62 13 24.88 14.86 25.39 17.43L25.69 18.93L27.22 19.04C28.78 19.14 30 20.45 30 22C30 23.65 28.65 25 27 25Z"
        fill="#005EE0"
      />
    </g>
    <defs>
      <clipPath id="clip0_2719_2140">
        <rect width="24" height="24" fill="white" transform="translate(8 7)" />
      </clipPath>
    </defs>
  </svg>
);
